import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {NavigationPathOrderStatusFilter, OrderStatus} from 'src/models/orders/orderStatus';
import {NavigationPathToSalesChannel, SalesChannel} from 'src/models/orders/sales.channel.enum';
import {Params} from '@angular/router';
import {NavigationPath} from 'src/models/navigation/navigation.path.enum';

export interface OrderFilterValues {
	orderStatus: OrderStatus[];
	searchQuery: string;
	orderNumberQuery: string;
	paymentFilters: string[];
	needsReview: boolean;
	ignoreNeedsReview: boolean;
	salesChannel: SalesChannel;
}

@Injectable({
	providedIn: 'root'
})
export class OrderFilterService {

	private orderFilter: BehaviorSubject<OrderFilterValues>;

	constructor() {
		this.orderFilter = new BehaviorSubject<OrderFilterValues>({
			orderStatus: [],
			searchQuery: '',
			orderNumberQuery: '',
			paymentFilters: [],
			needsReview: false,
			ignoreNeedsReview: false,
			salesChannel: SalesChannel.Octo,
		});
	}

	getOrderFilterObservable(): Observable<OrderFilterValues> {
		return this.orderFilter.asObservable();
	}

	updateFilterFromRouteParams(params: Params): OrderFilterValues {
		const currentFilterValues = this.getCurrentSearchFilterValues();
		currentFilterValues.orderStatus = this.getOrderStatusFilterFromNavigationPath(params.filter as NavigationPath);

		const channel = NavigationPathToSalesChannel.get(params.salesChannel);
		if (!channel) {
			throw Error(`Cant find sales-channel for navigation-path '${params.salesChannel}'`);
		}
		currentFilterValues.salesChannel = channel;

		currentFilterValues.ignoreNeedsReview = params.filter === NavigationPath.all;

		currentFilterValues.needsReview = params.filter === NavigationPath.inReview;
		return currentFilterValues;
	}

	private getOrderStatusFilterFromNavigationPath(statusKey: NavigationPath): OrderStatus[] {
		const statusFilter = NavigationPathOrderStatusFilter.get(statusKey);

		if (!statusFilter) {
			throw Error(`No Status-Mapping found for route-filter ${statusKey}`);
		}

		return statusFilter;
	}

	setNewFilter(orderFilterValues: OrderFilterValues): void {
		this.orderFilter.next(orderFilterValues);
	}

	setNewSearchQuery(searchQuery: string, orderNumberQuery: string): void {
		const currentValues = this.getCurrentSearchFilterValues();
		this.orderFilter.next({...currentValues, searchQuery, orderNumberQuery});
	}

	setPaymentFilters(payments: string[]): void {
		const currentValues = this.getCurrentSearchFilterValues();
		currentValues.paymentFilters = payments;
		this.orderFilter.next(currentValues);
	}

	getCurrentSearchFilterValues(): OrderFilterValues {
		return this.orderFilter.value;
	}
}

